import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    chartId: String,
    datasetIndex: Number
  };

  toggle(event) {
    const visible = event.target.checked;
    const wrapperController = this.chartWrapperController();
    if (wrapperController && typeof wrapperController.setDatasetVisibility === "function") {
      wrapperController.setDatasetVisibility(this.datasetIndexValue, visible);
    }
  }

  showAll(event) {
    const wrapperController = this.chartWrapperController();
    if (wrapperController && typeof wrapperController.showAll === "function") {
      wrapperController.showAll();
    }
  }

  hideAll(event) {
    const wrapperController = this.chartWrapperController();
    if (wrapperController && typeof wrapperController.hideAll === "function") {
      wrapperController.hideAll();
    }
  }

  chartWrapperController() {
    if (!this.chartIdValue) return null;

    const selector = `[data-controller~="iqr-chart-wrapper"][data-iqr-chart-wrapper-chart-id-value="${this.chartIdValue}"]`;
    const wrapperElement = document.querySelector(selector);
    if (!wrapperElement) return null;

    return this.application.getControllerForElementAndIdentifier(wrapperElement, "iqr-chart-wrapper");
  }
}

